import { render, staticRenderFns } from "./HotelWorkShift.vue?vue&type=template&id=ca03f1a0"
import script from "./HotelWorkShift.vue?vue&type=script&lang=js"
export * from "./HotelWorkShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports